import AccountContext from 'context/AccountContext';
import { useContext } from 'react';
import { isPermitForParkingZone } from 'utils/permitUtils';

const useHasPermitForZone = (parkZoneUid: string | undefined): boolean => {
  const {
    customer: { permits, licensePlateBasedPermits },
  } = useContext(AccountContext);

  return (
    permits?.some((p) => p && isPermitForParkingZone(parkZoneUid, p)) ||
    licensePlateBasedPermits?.some(
      (p) => p && isPermitForParkingZone(parkZoneUid, p)
    ) ||
    false
  );
};

export default useHasPermitForZone;
